'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/milestones/:milestoneId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/milestones/:milestoneId/enable', method: 'PUT'},
            delete: {url: 'api/milestones/:milestoneId/delete', method: 'PUT'},
            getDefault: {url: 'api/milestones/default', method: 'GET'},
            setDefault: {url: 'api/milestones/:milestoneId/default', method: 'PUT'},
            isUniqueName: {url: 'api/milestones/unique/name/:name', method: 'GET'},
            exists: {url: 'api/milestones/exists', method: 'GET'},
            getMilestones: {url: ' /api/milestones', method: 'GET'},
        });
    }];